import React from "react";
import Button from "@mui/material/Button";

export const FlowButtonSet: React.FC = () => (
  <>
    <Button variant="outlined">Back</Button>
    <Button>Next</Button>
  </>
)
